<script>
    import { db } from './stores.js';

    export let upcoming;
    let newCypher;
    let notificationTitle = "Notification Title";
    let notificationBody = "Notification Body";
    let notificationIcon = "https://notify.untilit.works/dwane-uiw-192-opt.png";
    let notificationImage = "https://notify.untilit.works/twitter-push-image-opt.png";
    let notificationClickAction = "https://cypher.untilit.works";
    let notificationTag = "live";


    let selectedCypher;

    console.log("upcoming: ", upcoming);

    // function selectCypher(id){
    //     selected
    //     console.log('newCypher: ', newCypher)
    // }

    function sendNotification() {
        console.log("selectedCypher: ", selectedCypher);
        console.log("notificationTitle: ", notificationTitle);
        console.log("notificationBody: ", notificationBody);
        // save to Firebase
        $db.collection("notifications").doc(`${selectedCypher}`).set({
            notification: {
                title: notificationTitle,
                body: notificationBody,
                icon: notificationIcon,
                image: notificationImage,
                click_action: notificationClickAction,
                tag: notificationTag
            }
        }, {merge: true}).then(() => {
            console.log("Upcoming cyphers successfully updated!");
        }).catch((error) => {
            console.error("Error updating upcoming cyphers: ", error);
        });

    }

</script>

<section>
    <div>
        {#each upcoming as cypher}
            <dwane-timer timer-deadline="{cypher}" countdown-start="3600000"></dwane-timer>
            <button on:click="{() => selectedCypher = cypher}">select</button>
        {/each}
    </div>
    <div>
        {#if selectedCypher}
            selected Cypher <br/>
            <dwane-timer timer-deadline="{selectedCypher}" countdown-start="3600000"></dwane-timer>
            <input bind:value={notificationTitle} /> <br/>
            <textarea bind:value={notificationBody} rows="5" cols="33"></textarea> <br/>
            icon: <input bind:value={notificationIcon} /> <br/>
            image: <input bind:value={notificationImage} /> <br/>
            click action: <input bind:value={notificationClickAction} /> <br/>
            tag: <input bind:value={notificationTag} /> <br/>

            <button on:click="{() => sendNotification(selectedCypher)}">send</button>
        {:else}
            select a cypher
        {/if}
    </div>
</section>

<style>
    section {
        display: flex;
        align-items: center;
        justify-content: space-around;
        height: 100%;
    }
    dwane-timer {
        --dwane-timer-font-family: "Roboto Mono";
        --dwane-timer-weekday-font-size: clamp(1.5rem, 1.5vw, 2rem);
        --dwane-timer-date-font-size: clamp(1.5rem, 1.5vw, 2rem);
        --dwane-timer-time-font-size: clamp(1.5rem, 1.5vw, 2rem);
        --dwane-timer-countdown-font-size: 3vmax;
        opacity: 0;
        transition:opacity 0.4s ease-in;
    }
    dwane-timer:defined {
        opacity: 1;
    }
    button {
        cursor: pointer;
    }

</style>